import { reactive } from 'vue';

export const criarPlaExpedicao = () => {
  return reactive({
    id: 0,
    idestabelecimento: 0,
    subtipo: '',
    anomes: 0,
    protocolo: '',
    idresponsavel: 0,
    nmresponsavel: '',
    idrt: 0,
    nmrt: '',
    lgdigitacao: 0,
    rtdigitacao: 'N',
    informacoes: '',
    status: 0,
    idlogin: 0,
    idusuario: 0
  });
};